import { Client } from '@stomp/stompjs';
import { config } from './config';
import { getAccessToken } from './auth';

export interface StatusRecord {
  type: string;
  message: string;
  payload?: unknown;
  timestamp: Date;
}

export async function connectStatusFeed(onRecord: (record: StatusRecord) => void): Promise<Client> {
  const token = await getAccessToken();
  const baseUrl = config.wsBase || `${window.location.origin.replace(/^http/, 'ws')}/ws`;
  const wsUrl = token ? `${baseUrl}?token=${encodeURIComponent(token)}` : baseUrl;

  const client = new Client({
    brokerURL: wsUrl,
    connectHeaders: {},
    debug: () => {},
    reconnectDelay: 3000,
  });

  client.onConnect = () => {
    client.subscribe('/user/queue/status', message => {
      try {
        const parsed = JSON.parse(message.body) as { type?: string; message?: string; payload?: unknown };
        onRecord({
          type: parsed.type ?? 'info',
          message: parsed.message ?? message.body,
          payload: parsed.payload,
          timestamp: new Date(),
        });
      } catch {
        onRecord({ type: 'info', message: message.body, timestamp: new Date() });
      }
    });
  };

  client.activate();
  return client;
}
